__turbopack_context__.v({
  "active": "PricingToggle-module-scss-module__ubYNDa__active",
  "alignToRight": "PricingToggle-module-scss-module__ubYNDa__alignToRight",
  "button": "PricingToggle-module-scss-module__ubYNDa__button",
  "dropdown": "PricingToggle-module-scss-module__ubYNDa__dropdown",
  "dropdownButton": "PricingToggle-module-scss-module__ubYNDa__dropdownButton",
  "item": "PricingToggle-module-scss-module__ubYNDa__item",
  "label": "PricingToggle-module-scss-module__ubYNDa__label",
  "planTypeToggle": "PricingToggle-module-scss-module__ubYNDa__planTypeToggle",
  "wrapper": "PricingToggle-module-scss-module__ubYNDa__wrapper",
});
